import React from 'react';
import { useDataProduct } from 'v2/queries/useDataProduct';
import { ActivityItemLinkCreatedEntityProps } from '../../types';
import { ActivityItemLinkCreatedDescription } from '../ActivityItemLinkCreatedDescription';

export function ActivityItemLinkCreatedDataProduct({
  objectID,
  searchID,
}: ActivityItemLinkCreatedEntityProps) {
  const { data: dataProduct } = useDataProduct({
    id: objectID,
  });

  if (dataProduct === undefined) {
    return null;
  }

  return (
    <ActivityItemLinkCreatedDescription
      entityName={dataProduct.name}
      searchID={searchID}
    />
  );
}
